<template>
    <div id="multiple-selection-settings">
        <div class="form-field">
            <label for="field-label" class="form-label">Alan Etiketi</label>
            <input
                type="text"
                id="field-label"
                class="form-input"
                placeholder="Bir soru girin"
                v-model="fieldLabel"
                @input="setFieldLabel(fieldLabel)"
            >
        </div>

        <div class="form-field">
            <label class="form-label">Etiket Hizalama</label>
            <div class="button-group">
                <button class="button" :class="{ active: labelAlign === 'left' }" @click="setLabelAlign('left')">SOL
                </button>
                <button class="button" :class="{ active: labelAlign === 'right' }" @click="setLabelAlign('right')">SAĞ
                </button>
                <button class="button" :class="{ active: labelAlign === 'top' }" @click="setLabelAlign('top')">ÜST
                </button>
            </div>
            <div class="checkbox-group">
                <input type="checkbox" id="default-align" class="checkbox" v-model="defaultAlign">
                <label for="default-align" class="checkbox-label">Varsayılan olarak ayarla</label>
            </div>
            <small class="form-description">Etiket metninin yatay olarak nasıl hizalanacağını seçin</small>
        </div>

        <div class="form-field">
            <label class="form-label">Zorunlu</label>
            <div class="toggle">
                <span class="toggle-option" :class="{ active: isRequired }"
                      @click="toggleRequired">{{ isRequired ? "AÇIK" : "KAPALI" }}</span>
            </div>
            <small class="form-description">Bu alan boşsa formun gönderilmesine izin vermeyin</small>
        </div>

        <div class="form-field">
            <label class="form-label">Alanı Kopyala</label>
            <button class="duplicate-button" @click="duplicateField">DUPLICATE</button>
            <small class="form-description">Bu alanın tüm kayıtlı ayarlarını koruyarak bir kopyasını oluşturun</small>
        </div>
    </div>
</template>

<script>
export default {
    name: "MultipleSelectionSettings",
    data() {
        return {
            fieldLabel: "",
            labelAlign: "top",
            defaultAlign: false,
            isRequired: false,
        };
    },
    methods: {
        setLabelAlign(align) {
            this.labelAlign = align;
            this.$emit("update-label-align-multiple-selection", align);
            console.log("Label alignment set to:", align);
        },
        toggleRequired() {
            this.isRequired = !this.isRequired;
            console.log("Field required set to:", this.isRequired);
        },
        duplicateField() {
            console.log("Field duplicated");
        },
        setFieldLabel(label) {
            this.$emit("update-field-label-multiple-selection", label);
        },
    },
};
</script>

<style lang="scss" scoped>
#multiple-selection-settings {
    padding: 15px;

    .form-field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;

        .form-label {
            margin-bottom: 5px;
            font-weight: bold;
            color: #333;
        }

        .form-input {
            padding: 10px;
            border: 1px solid #ccc;
            border-radius: 4px;
            background-color: #f9f9f9;
            color: #333;
            font-size: 16px;
        }

        .button-group {
            display: flex;
            margin-bottom: 10px;

            .button {
                flex: 1;
                padding: 10px;
                margin-right: 5px;
                border: none;
                border-radius: 4px;
                background-color: #e0e0e0;
                color: #333;
                font-size: 14px;
                cursor: pointer;
                text-align: center;

                &.active {
                    background-color: #4a90e2;
                    color: #fff;
                }

                &:last-child {
                    margin-right: 0;
                }
            }
        }

        .checkbox-group {
            display: flex;
            align-items: center;
            margin-bottom: 10px;

            .checkbox {
                margin-right: 5px;
            }

            .checkbox-label {
                font-size: 14px;
                color: #333;
            }
        }

        .form-description {
            margin-top: 5px;
            font-size: 12px;
            color: #666;
        }

        .toggle {
            display: flex;
            align-items: center;

            .toggle-option {
                padding: 10px;
                border: 1px solid #ccc;
                border-radius: 4px;
                background-color: #f0f0f0;
                color: #333;
                font-size: 14px;
                cursor: pointer;
                text-align: center;

                &.active {
                    background-color: #4a90e2;
                    color: #fff;
                }
            }
        }

        .duplicate-button {
            padding: 10px;
            border: none;
            border-radius: 4px;
            background-color: #e0e0e0;
            color: #333;
            font-size: 14px;
            cursor: pointer;
            width: fit-content;

            &:hover {
                background-color: #d0d0d0;
            }
        }
    }
}
</style>
